export default __webpack_public_path__ + "static/media/account.c300a767.svg";